const dependents = (control, fieldName, root = control.form) => root
    ?.querySelectorAll(`[data-revealed-by="${CSS.escape(fieldName)}"]`) ?? [];

export const revealDependents = (control, fieldName, visible) => {
    dependents(control, fieldName).forEach(dependent => {
        dependent.hidden = !visible;
    });
};

export const revealDependentsByValue = (control, root = control.form) => {
    if (!control.name) {
        return;
    }

    dependents(control, control.name, root).forEach(dependent => {
        if (dependent.dataset.revealedFor === undefined) {
            return;
        }

        const revealedFor = JSON.parse(dependent.dataset.revealedFor);

        dependent.hidden = !revealedFor.includes(control.value);
    });
};
